import { QUANTITY_UNIT, hasSelectedItems, preferredGroupKey, selectionSummaryLabel } from '@/components/Tickets/materialsOrderSelection';

const CHOSEN_ITEMS_SEPARATOR = ' · ';
const EMPTY_SELECTION_LABEL = 'Elige la cantidad de al menos un material';
const SHOW_OTHERS_LABEL = 'Ver otros materiales';
const HIDE_OTHERS_LABEL = 'Ocultar otros materiales';

export function splitGroupsByLine(groups, businessLine) {
  const preferredGroup = groups.find((group) => group.key === preferredGroupKey(businessLine));
  if (!preferredGroup) return { mainGroups: groups, otherGroups: [] };

  return { mainGroups: [preferredGroup], otherGroups: groups.filter((group) => group !== preferredGroup) };
}

function hasChosenItem(group, selection) {
  return group.items.some((item) => Boolean(selection[item.material_id]));
}

export function groupKeysWithSelection(groups, selection) {
  return groups.filter((group) => hasChosenItem(group, selection)).map((group) => group.key);
}

export function withGroupKey(groupKeys, groupKey) {
  return groupKeys.includes(groupKey) ? groupKeys : [...groupKeys, groupKey];
}

export function visibleOtherGroups({ otherGroups, isExpanded, keptGroupKeys, selection }) {
  if (isExpanded) return otherGroups;

  return otherGroups.filter((group) => keptGroupKeys.includes(group.key) || hasChosenItem(group, selection));
}

export function hiddenItemCount(otherGroups, visibleGroups) {
  const visibleKeys = visibleGroups.map((group) => group.key);

  return otherGroups
    .filter((group) => !visibleKeys.includes(group.key))
    .reduce((count, group) => count + group.items.length, 0);
}

export function isOthersToggleVisible({ otherGroups, isExpanded, hiddenCount }) {
  return otherGroups.length > 0 && (isExpanded || hiddenCount > 0);
}

export function otherGroupsToggleLabel(isExpanded, hiddenCount) {
  return isExpanded ? HIDE_OTHERS_LABEL : `${SHOW_OTHERS_LABEL} (${hiddenCount})`;
}

export function chosenItemsLabel(items, selection) {
  return items
    .filter((item) => Boolean(selection[item.material_id]))
    .map((item) => `${item.name} ${selection[item.material_id]}`)
    .join(CHOSEN_ITEMS_SEPARATOR);
}

export function orderSummaryLabel(selection) {
  return hasSelectedItems(selection) ? selectionSummaryLabel(selection) : EMPTY_SELECTION_LABEL;
}

export function selectedQuantityLabel(quantity) {
  return `${quantity} ${QUANTITY_UNIT}`;
}
